import { useWorkspaces } from '@/hooks/useWorkspaces'
import { useWorkspaceStore } from '@/store/workspaceStore'

export function useActiveWorkspaceName(fallback = '') {
  const activeId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const { data } = useWorkspaces()
  const name = data?.workspaces?.find((row) => row.id === activeId)?.name
  return String(name || fallback)
}
